export default __webpack_public_path__ + "static/media/hamburgerIcon.624ffa9b.svg";